/**
 * SECTOR-GRID
 * Grid of the 11 benchmark sectors — shared between SectorPickerModal (raw supervisor, its own
 * standalone modal) and the sector picker embedded inline in SupervisorUnmatchedQuestionsModal
 * (client / connected-as-supervisor, kept in the same modal rather than stacking a second one).
 */
import { useTranslation } from "react-i18next"
import {
  faMicrochip,
  faCartShopping,
  faIndustry,
  faPills,
  faGraduationCap,
  faBriefcase,
  faBullhorn,
  faLandmark,
  faHandHoldingHeart,
  faBuilding,
  faEllipsis
} from "@fortawesome/free-solid-svg-icons"
import CardContainer from "@/components/card-container"
import CardButton from "@/components/card-button"
import { BENCHMARK_SECTOR_LIST } from "@/redux/benchmark.types"

export const SECTOR_ICONS: Record<string, any> = {
  tech: faMicrochip,
  commerce: faCartShopping,
  industry: faIndustry,
  healthcare: faPills,
  education: faGraduationCap,
  services: faBriefcase,
  media: faBullhorn,
  public: faLandmark,
  associations: faHandHoldingHeart,
  housing: faBuilding,
  other: faEllipsis
}

// One color per sector, shared by the colored chips and the distribution bar of the accounts modal.
// "unassigned" keeps the #ff9500 warning orange already used for "Sans secteur" badges.
export const SECTOR_COLORS: Record<string, string> = {
  tech: "#4F6BED",
  commerce: "#E85D9A",
  industry: "#8D6E63",
  healthcare: "#12A594",
  education: "#8E4EC6",
  services: "#3B82A0",
  media: "#E5484D",
  public: "#5B6B8C",
  associations: "#46A758",
  housing: "#C9A227",
  other: "#98A2B3",
  unassigned: "#ff9500"
}

interface Props {
  current?: string | null
  onSelect: (sector: string) => void
}

export default function SectorGrid(props: Props) {
  const { t } = useTranslation()

  return (
    <CardContainer>
      {BENCHMARK_SECTOR_LIST.map((id) => (
        <CardButton
          key={id}
          isSmall
          title={t("benchmark_sector_" + id)}
          icon={SECTOR_ICONS[id]}
          isActive={props.current === id}
          onClick={() => props.onSelect(id)}
        />
      ))}
    </CardContainer>
  )
}
